(()=>{const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
// Desktop mega menu is click-to-toggle (no hover-open/hover-close).
// The menu remains open while the pointer moves; close only on outside click, Escape, or another top-level menu click.
const nav = document.querySelector('.header__inline-menu');
if (nav && window.matchMedia('(min-width: 990px)').matches) {
  const items = [...nav.querySelectorAll('details.mega-menu')];
  const closeItem = (item) => {
    item.open = false;
    const summary = item.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  };
  const syncExpanded = (item) => {
    const summary = item.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
  };
  items.forEach((item) => {
    syncExpanded(item);
    item.addEventListener('toggle', () => syncExpanded(item));
  });
  nav.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    if (!summary || !nav.contains(summary)) return;
    const current = summary.closest('details.mega-menu');
    if (!current) return;
    items.forEach((item) => { if (item !== current) closeItem(item); });
    // Do not prevent the native summary click: it toggles the selected menu.
  });
  document.addEventListener('click', (event) => {
    if (!nav.contains(event.target)) items.forEach(closeItem);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') items.forEach(closeItem);
  });
}
if(reduce)return;
// gentle parallax only on large screens; no layout movement and no horizontal image bleed
if(window.matchMedia('(min-width: 750px)').matches){const imgs=[...document.querySelectorAll('.section-dazzling-hero img,.section-dazzling-editorial img,.slideshow img,.image-banner img')];let ticking=false;const move=()=>{const vh=window.innerHeight;imgs.forEach(img=>{const r=img.getBoundingClientRect();if(r.bottom>0&&r.top<vh){const delta=(r.top+r.height/2-vh/2)*-.025;img.style.translate=`0 ${Math.max(-14,Math.min(14,delta))}px`;}});ticking=false};window.addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(move);ticking=true}},{passive:true});move();}
const els=[...document.querySelectorAll('.shopify-section:not(.header-section):not(.announcement-bar-section):not(.footer-section)')];els.forEach(el=>{if(el.querySelector('img,h2,.dl-section-title,.card-wrapper'))el.classList.add('dazzling-reveal')});if('IntersectionObserver'in window){const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}}),{threshold:.08,rootMargin:'0px 0px -35px 0px'});els.forEach(el=>{if(el.classList.contains('dazzling-reveal'))io.observe(el)});}else els.forEach(el=>el.classList.add('is-visible'));
})();